module.exports = __webpack_public_path__ + "assets/img/qr-logo.0c2ce805.png";